import React from 'react';
import { compose } from 'recompose';
import ManifestModal from './ManifestModal';
import { withValidationState } from './ValidationState';

export default compose(withValidationState)(ManifestModal);
